export default __webpack_public_path__ + "static/media/22_gallery.e89080a7.jpg";